import { useNavigate } from '@tanstack/react-router';

import { DataPrivacyStatement } from '@/components/DataPrivacyStatement';
import { NavigationBar } from '@/components/NavigationBar';
import StepperCard from '@/components/common/StepperCard.tsx';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card.tsx';
import { useRunOnce } from '@/hooks/use-run-once';
import { useSessionSave } from '@/hooks/use-session-save';
import { useSessionStore } from '@/hooks/use-session-store/use-session-store';
import { identifyUser, trackEligibilityCheckpoint } from '@/lib/analytics';
import { getBaseInsuranceEligibilityEventAttributes } from '@/types/insurance-builder.type';
import {
  type FormData,
  InsuranceFollowUpForm,
} from '@/views/insurance/flows/legacy/components/InsuranceFollowUpForm.tsx';

export const InsuranceFollowUp = () => {
  const navigate = useNavigate();
  const { saveSession } = useSessionSave();

  useRunOnce(function trackEligibilityCheckpointOnMount() {
    const { insuranceBuilder, insuranceZipCode } = useSessionStore.getState();
    const attributes = getBaseInsuranceEligibilityEventAttributes(
      insuranceBuilder,
      insuranceZipCode
    );

    trackEligibilityCheckpoint({
      ...attributes,
    });
  });

  const onSubmit = (formValues: FormData) => {
    useSessionStore.getState().updateState({
      contactPhoneNumber: formValues.phoneNumber,
      contactEmail: formValues.email,
    });

    if (formValues.email) {
      identifyUser(formValues.email);
    }

    saveSession();

    navigate({ to: '/insurance/benefits' });
  };

  const handleBack = () => navigate({ to: '/insurance/pre-discovery' });

  return (
    <section>
      <NavigationBar onBack={handleBack} backLabel="Insurance" stepIndicator="4 of 4" />
      <StepperCard currentStep={4} totalSteps={4}>
        <CardHeader>
          <CardTitle>Our team will need to verify your coverage over the phone</CardTitle>
        </CardHeader>

        <CardContent>
          <InsuranceFollowUpForm onSubmit={onSubmit} />
        </CardContent>
      </StepperCard>

      <DataPrivacyStatement />
    </section>
  );
};
